<template>
    <div>
        <div>
            <div style="display: flex;justify-content: space-between">
                <div>
                    <el-input placeholder="请输入关键字进行搜索，可以直接回车搜索..." prefix-icon="el-icon-search"
                              clearable
							  size="medium"
                              @clear="initEmps"
                              style="width: 350px;margin-right: 10px" v-model="keyword"
                              @keydown.enter.native="initEmps" :disabled="showAdvanceSearchView"></el-input>
                    <el-button icon="el-icon-search" type="primary" @click="initEmps" :disabled="showAdvanceSearchView">
                        搜索
                    </el-button>
<!--                    <el-button type="primary" @click="showAdvanceSearchView = !showAdvanceSearchView">
                        <i :class="showAdvanceSearchView?'fa fa-angle-double-up':'fa fa-angle-double-down'"
                           aria-hidden="true"></i>
                        高级搜索
                    </el-button> -->
                </div>
                <div>

                    <el-button type="primary" icon="el-icon-plus" @click="showAddEmpView">
                        添加用户
                    </el-button>
                </div>
            </div>
            <transition name="slide-fade">
                <div v-show="showAdvanceSearchView"
                     style="border: 1px solid #409eff;border-radius: 5px;box-sizing: border-box;padding: 5px;margin: 10px 0px;">
                    <el-row style="margin-top: 10px">
                        <el-col :span="6">
							<div class="flex-center advance_seit_box">
								<div class="box_tit">用户联系人：</div>
								<div>
									<el-input placeholder="请输入用户联系人" size="medium" v-model="searchValue.ktiContacts"></el-input>
								</div>
							</div>
                        </el-col>
						<el-col :span="6">
							<div class="flex-center advance_seit_box">
								<div class="box_tit">联系方式：</div>
								<div>
									<el-input placeholder="请输入用户联系人方式" size="medium" v-model="searchValue.ktiContactWay"></el-input>
								</div>
							</div>
						</el-col>
                        <el-col :span="6">
							<div class="flex-center advance_seit_box">
								<div class="box_tit">用户状态：</div>
								<div>
									<el-radio-group v-model="searchValue.ktiIsEnable">
										<el-radio :label="0">启用</el-radio>
										<el-radio :label="1">停用</el-radio>
									</el-radio-group>
								</div>
							</div>
                        </el-col>
                        <el-col :span="6" >
							<div class="txt_align_right advance_btn_warp">
								<el-button size="mini" icon="el-icon-search" type="primary" @click="initEmps('advanced')">搜索</el-button>
							</div>
                        </el-col>
                    </el-row>
                </div>
            </transition>
        </div>
        <div style="margin-top: 10px">
            <el-table
                    :data="emps"
                    stripe
                    border
                    v-loading="loading"
                    element-loading-text="正在加载..."
                    element-loading-spinner="el-icon-loading"
                    element-loading-background="rgba(0, 0, 0, 0.8)"
                    style="width: 100%">
                <!-- <el-table-column
                        type="selection"
                        width="55">
                </el-table-column> -->

                <el-table-column
                        prop="name"
                        align="center"
                        label="用户姓名"
                        min-width="15%">
                </el-table-column>

                <el-table-column
                        prop="username"
                        label="登录名"
                        align="center"
                        min-width="15%">
                </el-table-column>
				<el-table-column
				        prop="pwdnew"
				        label="密码"
				        align="center"
				        min-width="15%">
						<template slot-scope="scope">
							<div v-if="scope.row.pwdnew != null">{{scope.row.pwdnew}}</div>
							<div v-else>{{scope.row.username}}</div>
						</template>
				</el-table-column>

				<el-table-column
				        prop="roleName"
						label="所属角色"
				        align="center"
				        min-width="30%">
						<template slot-scope="scope">
							<span>{{ scope.row.treeNames || scope.row.roleName }}</span>
						</template>
				</el-table-column>
				<el-table-column
				        prop="phone"
						label="联系方式"
				        align="center"
				        min-width="10%">
				</el-table-column>
                <el-table-column
                        fixed="right"
                        min-width="15%"
						align="center"
                        label="操作">
                    <template slot-scope="scope">
                        <el-button @click="showEditEmpView(scope.row)" style="padding: 3px" size="mini" v-if="scope.row.id != '3' && scope.row.id != '4'">编辑</el-button>
                        <el-button @click="deleteEmp(scope.row)" style="padding: 3px" size="mini" type="danger" v-if="scope.row.id != '3' && scope.row.id != '4' && currentHr.roles[0].roleId == '1001'">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div style="display: flex;justify-content: flex-end">
                <el-pagination
                        background
                        @current-change="currentChange"
                        @size-change="sizeChange"
                        layout="sizes, prev, pager, next, jumper, ->, total, slot"
                        :total="total">
                </el-pagination>
            </div>
        </div>

        <el-dialog
                :title="title"
                :visible.sync="dialogVisible"
				:before-close="handlePopClose"
                width="80%">
            <div class="pop_block_warp">
				<div class="block">
					<p>用户基本信息</p>
					<el-form :model="emp" :rules="rules" ref="empForm">
					    <el-row>
					        <el-col >
					            <el-form-item label="用户姓名:" prop="name">
									<div class="input_box">
										<el-input size="mini" style="width: 150px" prefix-icon="el-icon-edit" v-model="emp.name"
										          placeholder="请输入用户姓名" maxlength="50" show-word-limit></el-input>
									</div>
					            </el-form-item>
					        </el-col>
						</el-row>
						<el-row>
					        <el-col >
					            <el-form-item label="登录名:" prop="username">
									<div class="input_box">
										<el-input size="mini" style="width: 150px" prefix-icon="el-icon-edit"  v-model="emp.username"
										          placeholder="请输入登录名" maxlength="20" show-word-limit ></el-input>
									</div>
					            </el-form-item>
					        </el-col>
						</el-row>
						<el-row>
						    <el-col >
						        <el-form-item label="登录密码:" prop="pwdnew">
									<div class="input_box">
										<el-input size="mini" autocomplete="new-password" type="password" style="width: 150px" prefix-icon="el-icon-edit" v-model="emp.pwdnew"
										          placeholder="请输入登录密码" maxlength="20" show-word-limit show-password></el-input>
									</div>
						        </el-form-item>
						    </el-col>
						</el-row>
						<el-row>
							<el-col >
							    <el-form-item label="联系方式:" prop="phone">
									<div class="input_box">
										<el-input size="mini" style="width: 150px" prefix-icon="el-icon-edit" v-model="emp.phone"
												  placeholder="请输入联系方式" maxlength="20" show-word-limit></el-input>
									</div>
							    </el-form-item>
							</el-col>
					    </el-row>
					    <el-row>
							<el-col >
							    <el-form-item label="用户状态:" prop="enabled">
							        <el-radio-group v-model="emp.enabled">
							            <el-radio :label="1">启用</el-radio>
							            <el-radio :label="0">停用</el-radio>
							        </el-radio-group>
							    </el-form-item>
							</el-col>
					    </el-row>
						<el-row v-if="emp.id">
							<el-col >
							    <el-form-item label="是否包含子用户状态:" prop="involveChild">
							        <el-radio-group v-model="emp.involveChild">
							            <el-radio :label="1">是</el-radio>
							            <el-radio :label="0">否</el-radio>
							        </el-radio-group>
							    </el-form-item>
							</el-col>
						</el-row>
					</el-form>
				</div>
                <div class="block">
					<p>用户角色</p>
					<el-tree :data="childRoles" show-checkbox node-key="id" default-expand-all 
						:expand-on-click-node="false" 
						:check-strictly="true" 
						@check="checkMenuTreeClick"
						ref="menusTree"
						>
						<span class="custom-tree-node" slot-scope="{ node, data }" >
							<span>{{ data.nameZh }}</span>
						</span>
					</el-tree>
				</div>
            </div>
            <span slot="footer" class="dialog-footer">
				<el-button @click="closePop">取 消</el-button>
				<el-button type="primary" @click="doAddEmp">确 定</el-button>
			  </span>
        </el-dialog>
    </div>
</template>

<script>
	import { mapState, mapGetters, mapActions } from 'vuex';
	//所需页面导入
	import vue from 'vue'
	import QRCode from 'qrcodejs2'
    export default {
        name: "Tenants",
        data() {
            return {
                searchValue: {
					ktiContacts:'',
					ktiContactWay:'',
					ktiIsEnable:''
                },
                title: '',
				showAdvanceSearchView: false,
                allDeps: [],
                emps: [],
                loading: false,
                dialogVisible: false,
				qrcodeDialogVisible:false,
                total: 0,
                page: 1,
                keyword: '',
                size: 10,
				tempTenantId:'',
                emp: {
					id:'',
					name:'',
					username:'',
					pwdnew:'',
					phone:'',
					enabled:1,
					involveChild:0,
					roleId:''
                },
                defaultProps: {
                    children: 'children',
                    label: 'name'
                },
                rules: {
                    name: [{required: true, message: '请输入用户姓名', trigger: 'blur'}],
					username: [{required: true, message: '请输入登录名', trigger: 'blur'}],
					pwdnew: [{required: true, message: '请输入登录密码', trigger: 'blur'}],
                    phone: [{required: true, message: '请输入联系方式', trigger: 'blur'}],
					enabled: [{required: true, message: '请选择用户状态', trigger: 'blur'}],
					involveChild: [{required: true, message: '请选择是否包含子用户状态', trigger: 'blur'}]
                },
				childRoles:[]
            }
        },
		computed:{
			...mapState([
			      'currentHr' // 将 `this.count` 映射为 `store.state.count`
			]),
		},
        mounted() {
            this.initEmps();
            this.initData();
			this.getUserRoleChildRoles()
        },
        methods: {
			checkMenuTreeClick(checkedNodes, checked, node){
				console.log(checkedNodes)
				if (checked) {
					this.$refs.menusTree.setCheckedKeys([checkedNodes.id]);
				} else {
					this.$refs.menusTree.setCheckedKeys([]);
				}
			},
			handlePopClose(done){
				this.emptyEmp();
				this.$refs.menusTree.setCheckedKeys([]);
				done();
			},
			closePop(){
				this.emptyEmp();
				this.$refs.menusTree.setCheckedKeys([]);
				this.dialogVisible = false
			},
            emptyEmp() {
                this.emp = {
					id:'',
                    name:'',
                    username:'',
					pwdnew:'',
                    phone:'',
                    enabled:1,
					involveChild:0,
					roleId:''
                }
                this.inputDepName = '';
            },
            showEditEmpView(data) {
				console.log(data)
				data.enabled = parseInt(data.enabled)
				data.involveChild = parseInt(data.involveChild)
                this.title = '编辑用户信息';
                this.emp = data;
				if(!this.emp.pwdnew){
					this.emp.pwdnew = this.emp.username
				}
                this.dialogVisible = true;
				this.$nextTick(()=>{
					this.$refs.menusTree.setCheckedKeys([data.roleId]);
				})
				
            },
            deleteEmp(data) {
                this.$confirm('此操作将永久删除【' + data.username + '】, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$confirm('此操作将永久删除【' + data.username + '】, 是否继续?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        this.deleteRequest("/userManager/basic/del/" + data.id).then(resp => {
                            if (resp) {
                                this.initEmps();
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: 'info',
                            message: '已取消删除'
                        });
                    });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            doAddEmp() {
				console.log(this.emp)
                if (this.emp.id) {
                    this.$refs['empForm'].validate(valid => {
                        if (valid) {
							var menuCheckedKeys =  this.$refs.menusTree.getCheckedKeys()
							if(menuCheckedKeys.length == 0){
								this.$message({
								    type: 'warning',
								    message: '请选择用户角色'
								});
								return;
							}
							this.emp.roleId = menuCheckedKeys[0]
                            this.postRequest("/userManager/basic/update", this.emp).then(resp => {
                                if (resp) {
                                    this.dialogVisible = false;
                                    this.initEmps();
                                }
                            })
                        }
                    });
                } else {
                    this.$refs['empForm'].validate(valid => {
                        if (valid) {
							var menuCheckedKeys =  this.$refs.menusTree.getCheckedKeys()
							if(menuCheckedKeys.length == 0){
								this.$message({
								    type: 'warning',
								    message: '请选择用户角色'
								});
								return;
							}
							this.emp.roleId = menuCheckedKeys[0]
                            this.postRequest("/userManager/basic/add", this.emp).then(resp => {
                                if (resp) {
                                    this.dialogVisible = false;
                                    this.initEmps();
                                }
                            })
                        }
                    });
                }
            },
            handleNodeClick(data) {
                this.inputDepName = data.name;
                this.emp.departmentId = data.id;
                this.popVisible = !this.popVisible
            },
            showDepView() {
                this.popVisible = !this.popVisible
            },
            showDepView2() {
                this.popVisible2 = !this.popVisible2
            },
            initData() {
				
            },
            sizeChange(currentSize) {
                this.size = currentSize;
                this.initEmps();
            },
            currentChange(currentPage) {
                this.page = currentPage;
                this.initEmps('advanced');
            },
            showAddEmpView() {
                this.emptyEmp();
                this.title = '添加用户';
                this.dialogVisible = true;
            },
            initEmps(type) {
                this.loading = true;
                let url = '/userManager/basic/getUpmsList?page=' + this.page + '&size=' + this.size;
                url += "&keyword=" + this.keyword;
                this.getRequest(url).then(resp => {
                    this.loading = false;
                    if (resp) {
                        this.emps = resp.data;
                        this.total = resp.total;
                    }
                });
            },
			getUserRoleChildRoles(){
				this.getRequest('/userManager/basic/getUserRoleChildRoles').then(resp => {
				    if (resp.status == 200) {
						this.childRoles = resp.obj
				    }
				});
			}
        }
    }
</script>

<style scoped lang="scss">
    /* 可以设置不同的进入和离开动画 */
    /* 设置持续时间和动画函数 */
    .slide-fade-enter-active {
        transition: all .8s ease;
    }

    .slide-fade-leave-active {
        transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
    }

    .slide-fade-enter, .slide-fade-leave-to
        /* .slide-fade-leave-active for below version 2.1.8 */
    {
        transform: translateX(10px);
        opacity: 0;
    }
	.el-form-item {
		display: flex;
		.input_box {
			width: 14.5rem;
			.el-input {
				width: 100% !important;
			}
		}
	}
	.advance_seit_box {
		line-height: 2.5rem;
		height: 2.5rem;
		font-size: 0.875rem;
		.box_tit {
			font-size: 0.875rem;
		}
	}
	.advance_btn_warp {
		line-height: 2.5rem;
		height: 2.5rem;
	}
	.pop_block_warp {
		display: flex;
		align-items: flex-start;
		justify-content: center;
		width: 100%;
		.block {
			width:50%;
			text-align: center;
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;
			p {
				font-size: 16px;
				font-weight: 700;
				text-align: center;
			}
		}
		.block:first-child {
			border-right: 1px solid #eff2f6;
		}
	}
	::v-deep .el-dialog__footer {
		text-align: center;
	}
</style>
